import { Exclude, Expose } from "class-transformer";

export const INPROGRESS = "000001";
export const REJECTED = "000031";
export const WITHDRAW = "WITHDR";
export const DELETE = "000002";
export const SUBMIT = "000050";
//Adding by vvs from bizfront
export const RECEIVED = "000050";
export const SUBMITTED = "000010";
export const UNDER_EVALUATION = "UNDEVA";
export const NEEDS_DIGITISION = "NEEDIG";
export const FURTHER_DIGITISING_INFO = "FURDIG";
export const DIGITISING_COMPLETE = "COMDIG";

export const PSC_CLARIFICATION = "PSCCLA";
export const CLARIFICATION_EXPIRED = "CLAEXP";
export const REPLY_TO_CLARIFICATION = "REPCLA";
export const READY_FOR_RANKING = "REARAN";
export const CAPTURED_IN_RANKING = "CAPRAN";
export const SELECTED = "000048";
export const FAILED_SELECTION = "000049";
export const APPEAL = "APPEAL";
export const APPEAL_REJECTED = "APPREJ";
export const CONTRACT = "CONTRA";
export const ADMINISTRATIVE_CORRECTION = "ADMCOR";
export const EXPIRED = "000007";
// Change Request Status
export const ADDENDUM_SIGNED = "ADDSIG";
export const CR_WITHDRAWN = "CRWITH";
export const BN_TO_RE_SUBMIT_THE_REQUEST = "BNRSUB";
export const FOR_INTERNAL_REVIEW = "INREW";
export const NO_CR_WAS_NECESSARY = "NOCR";
export const TO_ISSUE_CRRB_DECISION_LETTER = "CRRBDL";
export const CR_TO_BE_SUPERSEDED = "CRSUPE";
export const DECISION_TAKEN_NOTIFICATION_ACKNOWLEDGED = "DTNACK";
export const REQUEST_FOR_CLARIFICATIONS_SENT_PRIOR_TO_CRRB = "RCPRC";
export const REQUEST_FOR_CLARIFICATIONS_SENT_POST_CRRB = "RCPOC";
export const CLARIFICATION_RECEIVED = "CLREC";
export const AT_PSC_FOR_REVIEW = "PSCREW";
export const DECISION_TAKEN_APPROVED = "DTAPPR";
export const DECISION_TAKEN_PARTIALLY_APPROVED = "DTPAPP";
export const DECISION_TAKEN_NOT_APPROVED = "DTNAPP";




export class ContractItem {
    identification_code!: string;
    subject_id!: number;
    application_id!: number | null;
    contract_id!: number | null;
    contract_code!: number | null;
    description!: string | null;
    project_title!: string | null;
    cod_modu!: string;
    application_status_description!: string;//status
    application_status_code!: string;//status_code
    contract_status!: string;//sco_stato
    decision_letter_option!: string;
    can_change!: number | null;
    psc_clarification_count!: number;
    original_application_id!: number | null;
    is_change_request!: string;
    disclaimer!: string;

    @Exclude()
    private _can_complete!: number;
    @Exclude()
    private _can_progress!: number;
    @Exclude()
    private _can_proposal!: number;
    @Exclude()
    private _can_edit!: number;

    @Expose()
    get can_complete(): number {
        return this._can_complete;
    }
    set can_complete(can_complete: number) {
        this._can_complete = can_complete;
    }

    @Expose()
    get can_progress(): number {
        return this._can_progress;
    }
    set can_progress(can_progress: number) {
        this._can_progress = can_progress;
    }

    @Expose()
    get can_proposal(): number {
        return this._can_proposal;
    }
    set can_proposal(can_proposal: number) {
        this._can_proposal = can_proposal;
    }

    @Expose()
    get can_edit(): number {
        return this._can_edit;
    }
    set can_edit(can_edit: number) {
        this._can_edit = can_edit;
    }

    get canComplete(): boolean {
        return this._can_complete !== 0;
    }

    get canProgress(): boolean {
        return this._can_progress !== 0;
    }

    get canProposal(): boolean {
        return this._can_proposal !== 0;
    }

    get codeModu(): boolean {
        const cod = this.cod_modu?.trim() ?? '';
        return (
            !cod.endsWith('/I77.3/R') &&
            cod !== 'CSP/2023/I77.3/M' &&
            !cod.includes('I77.1.2')
        );
    }

    get canEdit(): boolean {
        return this._can_edit > 0;
    }

    get canChange(): boolean {
        return typeof this.can_change === "number";
    }

    @Exclude()

    get getStatus(): string {
        switch (this.application_status_code) {
            case INPROGRESS:
            case RECEIVED:
            case SUBMITTED:
            case UNDER_EVALUATION:
            case NEEDS_DIGITISION:
            case FURTHER_DIGITISING_INFO:
            case DIGITISING_COMPLETE:
            case PSC_CLARIFICATION:
            case CLARIFICATION_EXPIRED:
            case REPLY_TO_CLARIFICATION:
            case READY_FOR_RANKING:
            case CAPTURED_IN_RANKING:
            case FAILED_SELECTION:
            case SELECTED:
            case REJECTED:
            case APPEAL:
            case APPEAL_REJECTED:
            case WITHDRAW:
            case CONTRACT:
            case ADMINISTRATIVE_CORRECTION:
            case EXPIRED:
            case ADDENDUM_SIGNED:
            case CR_WITHDRAWN:
            case BN_TO_RE_SUBMIT_THE_REQUEST:
            case FOR_INTERNAL_REVIEW:
            case NO_CR_WAS_NECESSARY:
            case TO_ISSUE_CRRB_DECISION_LETTER:
            case CR_TO_BE_SUPERSEDED:
            case DECISION_TAKEN_NOTIFICATION_ACKNOWLEDGED:
            case REQUEST_FOR_CLARIFICATIONS_SENT_PRIOR_TO_CRRB:
            case REQUEST_FOR_CLARIFICATIONS_SENT_POST_CRRB:
            case CLARIFICATION_RECEIVED:
            case AT_PSC_FOR_REVIEW:
            case DECISION_TAKEN_APPROVED:
            case DECISION_TAKEN_PARTIALLY_APPROVED:
            case DECISION_TAKEN_NOT_APPROVED:
                return this.application_status_code;
            
            default:
                return INPROGRESS;
        }
    }
    
    @Exclude()
 
    get appStatus(): string {
        const scoStatoMapping: Record<string, string> = {
            "000010": "DRAFT",               //  status when Draft
            "000020": "SIGNED",              //  status when SIGNED
            "000030": "SIGNED",              //  status when Addendum
            "ESTEND": "SIGNED",              //  status when Extend Dates
            "CESTEN": "SIGNED",              //  status when Register Extension
            "000080": "MA Terminated",       //  status when MA Terminated
            "000090": "BN Withdrawal",       //  status when BN Withdrawal
            "000070": "Project Closed",      //  status when Project Closed / Success Close
            "CLOFUL": "Project Closed",      //  status when Project Closed / Closed with full recovery
            "CLOREC": "Project Closed",      //  status when Project Closed / Closed with recovery
            "ZERCLA": "Project Closed"       //  status when Project Closed / Closed with Zero Claim
        };
    
        if (this.cod_modu && this.cod_modu.startsWith("CSP")) {
        switch (this.getStatus) {
            case INPROGRESS:
                return "DRAFT";
            case RECEIVED:
                return "RECEIVED";
            case SUBMITTED:
                return "SUBMITTED";
            case UNDER_EVALUATION:
            case NEEDS_DIGITISION:
            case FURTHER_DIGITISING_INFO:
            case DIGITISING_COMPLETE:
            case READY_FOR_RANKING:
            case CAPTURED_IN_RANKING:
            case SELECTED:
            case REJECTED:
            case FAILED_SELECTION:
                return "UNDER EVALUATION";
            case PSC_CLARIFICATION:
                return "PSC CLARIFICATION";
            case CLARIFICATION_EXPIRED:
                return "CLARIFICATION EXPIRED";
            case REPLY_TO_CLARIFICATION:
                return "CLARIFICATION SUBMITTED";
            case APPEAL:
                return "APPEAL SUBMITTED";
            case APPEAL_REJECTED:
                return "APPEAL REJECTED";
            case WITHDRAW:
                return "APPLICATION WITHDRAWN";
            case ADMINISTRATIVE_CORRECTION:
                return "CONTRACTED";
            case EXPIRED:
                return "EXPIRED";
            case CONTRACT:
                if (this.contract_status && scoStatoMapping[this.contract_status]) {
                    return scoStatoMapping[this.contract_status];
                }

                if (this.decision_letter_option === "000001") {
                    return "AWARDED";
                } else if (this.decision_letter_option === "000002") {
                    return "CONDITIONAL AWARDED";
                } else if (this.decision_letter_option === "000003") {
                    return "AWARDED - RESERVE LIST";
                }

                return "CONTRACTED";

            default:
                return this.application_status_description;
        }
        }
        else if (this.cod_modu && this.cod_modu.endsWith("CR")) {
            switch (this.getStatus) {
                case CR_WITHDRAWN:
                    return "CR WITHDRAWN";
                case ADDENDUM_SIGNED:
                    return "ADDENDUM SIGNED";
                case BN_TO_RE_SUBMIT_THE_REQUEST:
                    return "BN TO RE-SUBMIT THE REQUEST";
                case FOR_INTERNAL_REVIEW:
                    return "FOR INTERNAL REVIEW";
                case NO_CR_WAS_NECESSARY:
                    return "NO CR WAS NECESSARY";
                case TO_ISSUE_CRRB_DECISION_LETTER:
                    return "TO ISSUE CRRB DECISION LETTER";
                case CR_TO_BE_SUPERSEDED:
                    return "CR TO BE SUPERSEDED";
                case DECISION_TAKEN_NOTIFICATION_ACKNOWLEDGED:
                    return "DECISION TAKEN - NOTIFICATION ACKNOWLEDGED";
                case REQUEST_FOR_CLARIFICATIONS_SENT_PRIOR_TO_CRRB:
                    return "REQUEST FOR CLARIFICATIONS SENT PRIOR TO CRRB";
                case REQUEST_FOR_CLARIFICATIONS_SENT_POST_CRRB:
                    return "REQUEST FOR CLARIFICATIONS SENT POST CRRB";
                case CLARIFICATION_RECEIVED:
                    return "CLARIFICATION RECEIVED";
                case AT_PSC_FOR_REVIEW:
                    return "AT PSC FOR REVIEW";
                case DECISION_TAKEN_APPROVED:
                    return "DECISION TAKEN - APPROVED";
                case DECISION_TAKEN_PARTIALLY_APPROVED:
                    return "DECISION TAKEN - PARTIALLY APPROVED";
                case DECISION_TAKEN_NOT_APPROVED:
                    return "DECISION TAKEN - NOT APPROVED";

                default:
                return this.application_status_description;
            }
        } else {
            return this.application_status_description;
        }
    }
    
  /* =================================
        Create change Request LOGIC
     ================================= */

    // CAPSP check 
    get isCAPSP(): boolean {
        return typeof this.cod_modu === 'string' && this.cod_modu.toUpperCase().includes('CSP');
    }

    // Has a linked contract
    get hasLinkedContract(): boolean {
        //return typeof this.contract_id === 'number' && this.contract_id > 0;
        return typeof this.application_status_code === 'string' && this.application_status_code.toUpperCase().includes('CONTRA');
    }

    // Status allowed for creating CR
    get isStatusAllowedForCR(): boolean {
        const s = this.appStatus;
        return s === 'DRAFT' || s === 'SIGNED';
    }

    // Explicitly denied statuses for CR creation
    get isStatusDeniedForCR(): boolean {
        const s = this.appStatus;
        return s === 'MA Terminated' || s === 'BN Withdrawal' || s === 'Project Closed';
    }
    
    get canCreateCR(): boolean {
        return (
        this.isCAPSP &&
        this.hasLinkedContract &&
        this.isStatusAllowedForCR &&
        !this.isStatusDeniedForCR &&
        typeof this.application_id === 'number' 
        );
    }
}

type CodModu =
    | "M01.1"
    | "M02.1"
    | "M03.1"
    | "M04.1"
    | "M04.2"
    | "M04.3"
    | "M04.4"
    | "M06.1"
    | "M06.4"
    | "M10.2"
    | "M16.2"
    | "M16.4"
    | "M16.6"
    | "M19.1"
    | "M19.2"
    | "M19.3"
    | "M19.4"
    | "M20";

export interface ProgressPaths {
    "budget-components": number;
    "budget-components-m6-p1": number;
    "budget-progress": number;
    "final-remarks": number;
    "measure-specific-targets-m1-p1": number;
    "measure-specific-targets-m4-p1": number;
    "measure-specific-targets-m4-p2": number;
    "measure-specific-targets-m4-p3-roads": number;
    "measure-specific-targets-m4-p3-water": number;
    "measure-specific-targets-m4-p4": number;
    "measure-specific-targets-m6-p1": number;
    "project-status-update": number;
}
export class ProgressContract {
    identification_code!: string;
    project_app_id!: number;
    application_id!: number;
    contract_id!: number;
    contract_code!: string;
    description!: string | null;
    project_title!: string;
    application_status_description!: string;//status
    cod_modu!: CodModu;
    subject_id!: number;
    measure!: string;
    proj_dt_start!: number;
    proj_dt_end!: number;
    total_pub_elig_amount!: number;
    pub_elig!: number;
    priv_share!: number;
    total_proj_cost!: number;
    paths!: ProgressPaths;
    type_modu!: "roads" | "water";
    @Exclude()
    _can_edit!: number;
    @Expose()
    get can_edit(): number {
        return this._can_edit;
    }
    set can_edit(can_edit: number) {
        this._can_edit = can_edit;
    }

    get canEdit(): boolean {
        return !!this._can_edit;
    }

    toString(): string {
        return `${this.cod_modu} | ${this.identification_code} | ${Math.abs(this.application_id)} | ${
            this.project_title
        }`;
    }
}
export interface ClosurePaths {
    "best-practices": number;
    disclaimer: number;
    "financial-overview": number;
    "financial-overview-m6-p1": number;
    "key-indicators-m4-p1": number;
    "key-indicators-m4-p3-roads": number;
    "key-indicators-m4-p3-water": number;
    "key-indicators-m4-p4": number;
    "key-indicators-m6-p1": number;
    "project-implementation": number;
}
export class ClosureContract {
    agri_activity!: string | null;
    application_id!: number;
    cod_modu!: CodModu;
    contract_code!: string;
    contract_id!: number;
    description!: string | null;
    dt_grant_agreement!: number;
    grant_amount!: number;
    identification_code!: string;
    measure!: string;
    paths!: ClosurePaths;
    proj_dt_end!: number;
    proj_duration!: number;
    proj_focus_target_area!: string;
    project_app_id!: number;
    project_title!: string;
    size_ha!: number | null;
    application_status_description!: string;//status
    subject_id!: number;
    total_proj_cost!: number;
    type_modu!: "roads" | "water";

    @Exclude() private _can_edit!: number;

    @Expose()
    get can_edit(): number {
        return this._can_edit;
    }
    set can_edit(can_edit: number) {
        this._can_edit = can_edit;
    }

    get canEdit(): boolean {
        return !!this._can_edit;
    }

    toString(): string {
        return `${this.cod_modu} | ${this.identification_code} | ${Math.abs(this.application_id)} | ${
            this.project_title
        }`;
    }
}

export class PrintQueueData {
    print_id!: string;
    description!: string | null;
    output_type!: string;
    queued!: boolean;
    queue_running!: boolean;
    queue_result!: QueueResult;
    file_id!: number;
    print_log_id!: number;
    print_date!: string;
}

export class BulkPrintQueueData {
    queued!: boolean;
    queue_result!: QueueResult;
    prints!: PrintQueueData[];
}

export type QueueResult = "Queued" | "Running" | "Done" | "Out of time" | "Stopped" | "Replacing" | "Error" | "Unknown";

